/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Start_TitleInputs */

const en_fw_guide_start_title = /** @type {(inputs: Fw_Guide_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manga or anime: where should you start?`)
};

const zh_fw_guide_start_title = /** @type {(inputs: Fw_Guide_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先看漫画还是先看动画？`)
};

/**
* | output |
* | --- |
* | "Manga or anime: where should you start?" |
*
* @param {Fw_Guide_Start_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_start_title = /** @type {((inputs?: Fw_Guide_Start_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Start_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_start_title(inputs)
	return zh_fw_guide_start_title(inputs)
});
export { fw_guide_start_title as "fw.guide.start.title" }